<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="tabsClick" v-model="tabVal">
      <el-tab-pane
        v-for="item in EXTERNAL_SERVICE_STATUS"
        :key="item.key"
        :name="item.key + ''"
        :label="item.value"
        v-loading="listLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#e6ebf54d"
      >
        <el-form
          ref="form"
          label-position="left"
          :style="{
            width:
              EXTERNAL_SERVICE_STATUS_.ALIPAY !== settingData.type ? '80%' : 'calc(100% - 20px)',
            minHeight: 'calc(100vh - 200px)',
            padding: '15px 20px'
          }"
        >
          <el-row :gutter="10">
            <!--              状态-->
            <el-col :xs="24" :sm="16" :xl="16">
              <el-form-item label="状态">
                <el-switch
                  v-model="settingData.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="onSwitch"
                  :disabled="EXTERNAL_SERVICE_STATUS_.ALIPAY !== settingData.type && !isEdit"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col
              v-if="EXTERNAL_SERVICE_STATUS_.ALIPAY !== settingData.type"
              :xs="24"
              :sm="8"
              :xl="8"
              style="text-align: right"
            >
              <el-button type="primary" v-show="!isEdit" @click="isEdit = true">编辑</el-button>
              <el-button type="success" v-show="isEdit" @click="saveOk" :loading="btnLoading"
                >保存</el-button
              >
            </el-col>
            <el-col
              v-if="EXTERNAL_SERVICE_STATUS_.ALIPAY == settingData.type && settingData.status"
              :xs="24"
              :sm="8"
              :xl="8"
              style="text-align: right"
            >
              <el-button type="primary" @click="checkDialogFormVisible(true, {})">新增</el-button>
            </el-col>
          </el-row>
          <!--          微信-->
          <div v-if="EXTERNAL_SERVICE_STATUS_.WECHAT === settingData.type && settingData.status">
            <el-form-item label="微信APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="微信商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                style="width: 100%"
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="公钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.pubKey }}</span>
                <span @click="copyClick(settingData.content.pubKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                style="width: 100%"
                v-model="settingData.content.pubKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="私钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.priKey }}</span>
                <span @click="copyClick(settingData.content.priKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                style="width: 100%"
                v-model="settingData.content.priKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="公钥ID">
              <span v-if="!isEdit">{{ settingData.content.pubKeyId }}</span>
              <el-input
                v-model="settingData.content.pubKeyId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户序列号">
              <span v-if="!isEdit">{{ settingData.content.serNum }}</span>
              <el-input
                v-model="settingData.content.serNum"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="V3密钥">
              <div v-if="!isEdit" class="key_pre">
                <span> {{ settingData.content.v3Key }}</span>
                <span @click="copyClick(settingData.content.v3Key)" class="copy_key_pre">复制</span>
              </div>
              <el-input
                v-model="settingData.content.v3Key"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!--          支付宝支付-->

          <!-- 支付宝支付列表 -->
          <div v-if="EXTERNAL_SERVICE_STATUS_.ALIPAY === settingData.type && settingData.status">
            <el-table
              v-loading="listLoading"
              :data="settingData.content"
              element-loading-text="Loading"
              size="small"
              border
              fit
            >
              <el-table-column
                align="center"
                prop="name"
                label="商户名"
                width="130"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="appId"
                label="支付宝APPID"
                width="130"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="priKey"
                label="应用私钥"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="aliPubKey"
                label="支付宝公钥"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="certContent"
                label="应用公钥证书"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="publicCertContent"
                label="支付宝公钥证书"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="rootCertContent"
                label="支付宝根证书"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column align="center" prop="alipayStatus" label="状态" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.alipayStatus === 1">启用</span>
                  <span v-else>停用</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    size="mini"
                    @click="checkDialogFormVisible(true, scope.row, scope.$index)"
                    >编辑</el-button
                  >
                  <el-button
                    v-if="scope.row.alipayStatus !== 1"
                    type="danger"
                    size="mini"
                    @click="deleteAlipay(scope.row, scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!--         jeep支付-->
          <div
            v-if="
              settingData.status && [EXTERNAL_SERVICE_STATUS_.JEEP_PAY].includes(settingData.type)
            "
          >
            <el-form-item label="JeepayAPPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="API密钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.apiKey }}</span>
                <span @click="copyClick(settingData.content.apiKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.apiKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!--          壹玖-->
          <div
            v-if="
              settingData.status && [EXTERNAL_SERVICE_STATUS_.YI_JIU].includes(settingData.type)
            "
          >
            <el-form-item label="壹玖APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="API密钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.apiKey }}</span>
                <span @click="copyClick(settingData.content.apiKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.apiKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="微信支付方式">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ getValue(WECHAT_CODE, settingData.content.wechatCode) }}</span>
              </div>
              <el-select
                v-model="settingData.content.wechatCode"
                placeholder="请选择"
                style="width: 100%"
                class="filter-item"
                clearable
                v-else
              >
                <el-option
                  v-for="item in WECHAT_CODE"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="支付宝支付方式">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ getValue(ALIPAY_CODE, settingData.content.alipayCode) }}</span>
              </div>
              <el-select
                v-model="settingData.content.alipayCode"
                placeholder="请选择"
                style="width: 100%"
                class="filter-item"
                clearable
                v-else
              >
                <el-option
                  v-for="item in ALIPAY_CODE"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </div>

          <!--          支付宝登录-->
          <div
            v-if="EXTERNAL_SERVICE_STATUS_.ALIPAY_LOGIN === settingData.type && settingData.status"
          >
            <el-form-item label="商户名">
              <span v-if="!isEdit">{{ settingData.content.name }}</span>
              <el-input
                v-model="settingData.content.name"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>

            <el-form-item label="支付宝APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>

            <el-form-item label="应用私钥">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.priKey }}</span>
                <span @click="copyClick(settingData.content.priKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.priKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="支付宝公钥">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.aliPubKey }}</span>
                <span @click="copyClick(settingData.content.aliPubKey)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.aliPubKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>

            <el-form-item label="应用公钥证书">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.certContent }}</span>
                <span @click="copyClick(settingData.content.certContent)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.certContent"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>

            <el-form-item label="支付宝公钥证书">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.publicCertContent }}</span>
                <span @click="copyClick(settingData.content.publicCertContent)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.publicCertContent"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>

            <el-form-item label="支付宝根证书">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.rootCertContent }}</span>
                <span @click="copyClick(settingData.content.rootCertContent)" class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.rootCertContent"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!-- Apple登录 -->
          <div
            v-if="EXTERNAL_SERVICE_STATUS_.APPLE_LOGIN === settingData.type && settingData.status"
          >
            <el-alert
              title="Apple 原生一键登录只需配置客户端 ID；服务端不会保存 Apple 私钥。"
              type="info"
              :closable="false"
              show-icon
              style="margin-bottom: 20px"
            />
            <el-form-item label="Client ID（Bundle ID）" required>
              <span v-if="!isEdit">{{ settingData.content.clientIds }}</span>
              <div v-else style="width: 100%">
                <el-input
                  v-model.trim="settingData.content.clientIds"
                  placeholder="例如：com.tbmall.app"
                  size="small"
                />
                <div class="field-help">
                  填写 iOS 打包使用的 Bundle ID；如同时有多个客户端，使用英文逗号分隔。
                </div>
              </div>
            </el-form-item>
            <el-form-item label="Apple公钥地址">
              <span v-if="!isEdit">{{ settingData.content.keysUrl }}</span>
              <div v-else style="width: 100%">
                <el-input
                  v-model.trim="settingData.content.keysUrl"
                  placeholder="https://appleid.apple.com/auth/keys"
                  size="small"
                />
                <div class="field-help">通常无需修改，系统仅允许 Apple 官方 HTTPS 地址。</div>
              </div>
            </el-form-item>
          </div>

          <!-- 抖音支付 -->
          <div
            v-if="
              EXTERNAL_SERVICE_STATUS_.DOUYIN_PAY === settingData.type &&
                settingData.status
            "
          >
            <el-alert
              title="抖音支付支持 App 支付、订单查询和原路退款；提现采用后台审核后人工打款。"
              type="info"
              :closable="false"
              show-icon
              style="margin-bottom: 20px"
            />
            <el-form-item label="应用 App ID" required>
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.appId"
                placeholder="抖音支付应用 App ID"
                size="small"
              />
            </el-form-item>
            <el-form-item label="商户号" required>
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.mchId"
                placeholder="抖音支付商户号"
                size="small"
              />
            </el-form-item>
            <el-form-item label="商户证书序列号" required>
              <span v-if="!isEdit">{{ settingData.content.merchantSerialNumber }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.merchantSerialNumber"
                placeholder="商户证书序列号"
                size="small"
              />
            </el-form-item>
            <el-form-item label="商户私钥" required>
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.merchantPrivateKey }}</span>
              </div>
              <el-input
                v-else
                v-model="settingData.content.merchantPrivateKey"
                type="textarea"
                :rows="8"
                placeholder="请输入 PKCS8 PEM 商户私钥"
              />
            </el-form-item>
            <el-form-item label="平台公钥证书" required>
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{ settingData.content.platformCertificate }}</span>
              </div>
              <el-input
                v-else
                v-model="settingData.content.platformCertificate"
                type="textarea"
                :rows="8"
                placeholder="请输入抖音支付平台公钥证书（PEM 格式）"
              />
              <div class="field-help">参数名：platformCertificate</div>
            </el-form-item>
            <el-form-item label="回调解密密钥" required>
              <span v-if="!isEdit">{{ settingData.content.encryptKey }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.encryptKey"
                type="password"
                show-password
                placeholder="抖音支付回调解密密钥"
                size="small"
              />
            </el-form-item>
            <el-form-item label="支付回调地址" required>
              <span v-if="!isEdit">{{ settingData.content.notifyUrl }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.notifyUrl"
                placeholder="https://域名/paycenter/douyin/callback"
                size="small"
              />
            </el-form-item>
            <el-form-item label="退款回调地址" required>
              <span v-if="!isEdit">{{ settingData.content.refundNotifyUrl }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.refundNotifyUrl"
                placeholder="https://域名/paycenter/douyin/refund/callback"
                size="small"
              />
            </el-form-item>
            <el-form-item label="App 回跳 Scheme" required>
              <span v-if="!isEdit">{{ settingData.content.callbackScheme }}</span>
              <el-input
                v-else
                v-model.trim="settingData.content.callbackScheme"
                placeholder="例如 trustbridgeapp"
                size="small"
              />
            </el-form-item>
            <el-form-item label="提现方式">
              <span>人工审核 + 人工打款</span>
              <div class="field-help">
                抖音支付 OpenSDK 不提供商户向用户自动提现接口，系统不会伪造自动提现调用。
              </div>
            </el-form-item>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <!-- 支付宝弹窗 -->
    <el-dialog
      :visible.sync="aliPayDialogVisible"
      :title="aliPaySettingData.index !== -1 ? '编辑支付宝支付配置' : '新增支付宝支付配置'"
    >
      <el-form :model="aliPaySettingData">
        <el-row :gutter="10" v-if="aliPaySettingData.index !== -1">
          <!--              状态-->
          <el-col :xs="24" :sm="16" :xl="16">
            <el-form-item label="启用状态">
              <el-switch
                v-model="aliPaySettingData.alipayStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEditAliPay"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8" style="text-align: right">
            <el-button type="primary" v-show="!isEditAliPay" @click="isEditAliPay = true"
              >编辑</el-button
            >
            <el-button type="success" v-show="isEditAliPay" @click="saveOk" :loading="btnLoading"
              >保存</el-button
            >
          </el-col>
        </el-row>

        <el-row :gutter="10" v-else>
          <el-col :xs="24" :sm="16" :xl="16" right>
            <el-button type="success" v-show="isEditAliPay" @click="saveOk" :loading="btnLoading"
              >保存</el-button
            >
          </el-col>
        </el-row>
        <template v-if="aliPaySettingData.index === -1 || aliPaySettingData.alipayStatus == 1">
          <el-form-item label="商户名">
            <span v-if="!isEditAliPay">{{ aliPaySettingData.name }}</span>
            <el-input v-model="aliPaySettingData.name" placeholder="请输入" size="small" v-else />
          </el-form-item>
          <el-form-item label="支付宝APPID">
            <span v-if="!isEditAliPay">{{ aliPaySettingData.appId }}</span>
            <el-input v-model="aliPaySettingData.appId" placeholder="请输入" size="small" v-else />
          </el-form-item>
          <el-form-item label="应用私钥">
            <div v-if="!isEditAliPay" class="key_pre">
              <span class="key_pre_value">{{ aliPaySettingData.priKey }}</span>
              <span @click="copyClick(aliPaySettingData.priKey)" class="copy_key_pre">复制</span>
            </div>
            <el-input
              v-model="aliPaySettingData.priKey"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 14 }"
              v-else
            />
          </el-form-item>
          <el-form-item label="支付宝公钥">
            <div v-if="!isEditAliPay" class="key_pre">
              <span class="key_pre_value">{{ aliPaySettingData.aliPubKey }}</span>
              <span @click="copyClick(aliPaySettingData.aliPubKey)" class="copy_key_pre">复制</span>
            </div>
            <el-input
              v-model="aliPaySettingData.aliPubKey"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 14 }"
              v-else
            />
          </el-form-item>

          <el-form-item label="应用公钥证书">
            <div v-if="!isEditAliPay" class="key_pre">
              <span class="key_pre_value">{{ aliPaySettingData.certContent }}</span>
              <span @click="copyClick(aliPaySettingData.certContent)" class="copy_key_pre"
                >复制</span
              >
            </div>
            <el-input
              v-model="aliPaySettingData.certContent"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 14 }"
              v-else
            />
          </el-form-item>

          <el-form-item label="支付宝公钥证书">
            <div v-if="!isEditAliPay" class="key_pre">
              <span class="key_pre_value">{{ aliPaySettingData.publicCertContent }}</span>
              <span @click="copyClick(aliPaySettingData.publicCertContent)" class="copy_key_pre"
                >复制</span
              >
            </div>
            <el-input
              v-model="aliPaySettingData.publicCertContent"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 14 }"
              v-else
            />
          </el-form-item>

          <el-form-item label="支付宝根证书">
            <div v-if="!isEditAliPay" class="key_pre">
              <span class="key_pre_value">{{ aliPaySettingData.rootCertContent }}</span>
              <span @click="copyClick(aliPaySettingData.rootCertContent)" class="copy_key_pre"
                >复制</span
              >
            </div>
            <el-input
              v-model="aliPaySettingData.rootCertContent"
              placeholder="请输入"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 14 }"
              v-else
            />
          </el-form-item>
        </template>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOutsideDetail,
  editYijiu,
  editWechat,
  editJeepay,
  editAliLogin,
  editAppleLogin,
  editDouyinPay,
  editAliPay,
  switchAliPayStatus
} from "@/api/system.js";
import {
  getValue,
  EXTERNAL_SERVICE_STATUS,
  EXTERNAL_SERVICE_STATUS_,
  WECHAT_CODE,
  ALIPAY_CODE
} from "@/utils/enumUtile";
import { copyClick } from "@/utils/index.js";

export default {
  name: "index",
  computed: {
    EXTERNAL_SERVICE_STATUS() {
      return EXTERNAL_SERVICE_STATUS;
    },
    EXTERNAL_SERVICE_STATUS_() {
      return EXTERNAL_SERVICE_STATUS_;
    },
    WECHAT_CODE() {
      return WECHAT_CODE;
    },
    ALIPAY_CODE() {
      return ALIPAY_CODE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      listLoading: false,
      tabVal: null,
      isEdit: false,
      isEditAliPay: false,
      btnLoading: false,
      settingData: {},
      rangeNumber: 10,
      itemSm: 24,
      itemXl: 24,
      aliPayDialogVisible: false,
      aliPaySettingData: {}
    };
  },
  created() {
    const type = EXTERNAL_SERVICE_STATUS[0].key;
    this.getList(type);
  },
  watch: {},
  methods: {
    getValue,
    copyClick,
    /**
     * 查询用户列表
     */
    getList(type) {
      this.tabVal = type + "";
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = {
        type
      };
      getOutsideDetail(params)
        .then(response => {
          let data = {};
          if (response && response.bizcode === 100) {
            data = response.data || {};
            if (data && Object.keys(data).length !== 0) {
              data.status = data.status === 1 ? true : false;
              // 支付宝支付切换字段extend-->content;
              if (type == EXTERNAL_SERVICE_STATUS_.ALIPAY) {
                data.content = data.extend || JSON.stringify([]);
              }
              if (!data.content) {
                data.content = this.addTr(type);
              } else {
                //  data.content = data.content.replace(/[\\n]/g, "\n");
                data.content = JSON.parse(data.content);
              }
            } else {
              const currentType = parseInt(type, 10);
              data.status = false;
              data.content = this.addTr(currentType);
              data.type = currentType;
            }
          }
          this.settingData = data;
        })
        .finally(() => {
          loading.close();
        });
    },
    /**
     * tab 切换
     * @param e
     */
    async tabsClick(e) {
      this.isEdit = false;
      this.settingData = {};
      this.aliPaySettingData = {};
      console.log("e.name----", e.name);
      this.getList(e.name);
    },
    checkDialogFormVisible(visible, row, index = -1) {
      if (visible) {
        this.aliPaySettingData = JSON.parse(JSON.stringify(row));
        this.aliPayDialogVisible = visible;
        this.aliPaySettingData.index = index;
        this.isEditAliPay = index === -1 ? true : false;
        console.log("this.settingData----", this.aliPayDialogVisible, this.aliPaySettingData);
      }
    },
    // 支付宝支付删除
    deleteAlipay(index) {
      this.aliPaySettingData.index = index;
      this.saveOk("delete");
    },

    async onSwitch() {
      if (EXTERNAL_SERVICE_STATUS_.ALIPAY == this.settingData.type) {
        const resp = await switchAliPayStatus({
          status: this.settingData.status ? 1 : 0
        });
        if (resp && resp.bizcode === 100) {
          const selTab = parseInt(this.tabVal, 10);
          this.getList(selTab);
          this.$notify({
            title: "成功",
            message: "更新成功",
            type: "success",
            duration: 2000
          });
        }
      }
    },
    /**
     * 保存
     */
    async saveOk(type) {
      const selTab = parseInt(this.tabVal, 10);
      const settingData = this.settingData;
      if (
        selTab === EXTERNAL_SERVICE_STATUS_.APPLE_LOGIN &&
        settingData.status &&
        !(settingData.content.clientIds || "").trim()
      ) {
        this.$message.error("请输入Apple Client ID（Bundle ID）");
        return;
      }
      if (selTab === EXTERNAL_SERVICE_STATUS_.DOUYIN_PAY && settingData.status) {
        const content = settingData.content || {};
        const requiredFields = [
          ["appId", "应用 App ID"],
          ["mchId", "商户号"],
          ["merchantSerialNumber", "商户证书序列号"],
          ["merchantPrivateKey", "商户私钥"],
          ["platformCertificate", "平台公钥证书"],
          ["encryptKey", "回调解密密钥"],
          ["notifyUrl", "支付回调地址"],
          ["refundNotifyUrl", "退款回调地址"],
          ["callbackScheme", "App 回跳 Scheme"]
        ];
        const missing = requiredFields.find(([key]) => !(content[key] || "").trim());
        if (missing) {
          this.$message.error(`请输入${missing[1]}`);
          return;
        }
      }
      const params = {
        status: settingData.status ? 1 : 0,
        content: JSON.stringify(settingData.content)
      };
      let resp = null;
      if (selTab === EXTERNAL_SERVICE_STATUS_.JEEP_PAY) {
        // jeepay支付
        resp = await editJeepay(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.WECHAT) {
        // 微信
        resp = await editWechat(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.ALIPAY) {
        // 支付宝支付
        const aliPayParams = {
          alipayStatus:
            this.aliPaySettingData.alipayStatus || this.aliPaySettingData.index === -1 ? 1 : 0,
          ...this.aliPaySettingData
        };
        if (this.aliPaySettingData.index !== -1) {
          settingData.content.splice(
            this.aliPaySettingData.index,
            1,
            type === "delete" ? {} : aliPayParams
          );
          settingData.content = settingData.content.filter(item => JSON.stringify(item) !== "{}");

          // 如果当前alipayStatus=true，其他都设为false
          settingData.content.forEach((item, index) => {
            if (index == this.aliPaySettingData.index) {
              item.alipayStatus = 1;
            } else {
              item.alipayStatus = 0;
            }
          });

          // 重新排序，如果alipayStatus= 1 放在数组第一个，alipayStatus=0的放在数组的后面
          settingData.content.sort((a, b) => {
            return b.alipayStatus - a.alipayStatus;
          });

          console.log("支付宝支付-1222", settingData.content);
        } else {
          // 前插入
          settingData.content = settingData.content || [];

          settingData.content.unshift(aliPayParams);
        }

        console.log("支付宝支付-1", settingData.content);
        params.extend = JSON.stringify(settingData.content);

        console.log("支付宝支付-2", params);
        delete params.content;
        console.log("支付宝支付-3", params);
        resp = await editAliPay(params);
        console.log("支付宝支付-4", resp);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.YI_JIU) {
        // 壹玖
        resp = await editYijiu(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.ALIPAY_LOGIN) {
        // 支付宝登录
        params.rootCertContent = settingData.content.rootCertContent;
        params.publicCertContent = settingData.content.publicCertContent;
        resp = await editAliLogin(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.APPLE_LOGIN) {
        resp = await editAppleLogin(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.DOUYIN_PAY) {
        settingData.content.withdrawMode = "MANUAL";
        params.content = JSON.stringify(settingData.content);
        resp = await editDouyinPay(params);
      }
      if (resp && resp.bizcode === 100) {
        this.isEdit = false;
        this.aliPayDialogVisible = false;
        this.getList(selTab);
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000
        });
      }
    },
    /**
     * 添加item
     * @param index
     */
    addTr(type) {
      console.log("type", type);
      let data = {};
      // 微信
      if (type === EXTERNAL_SERVICE_STATUS_.WECHAT) {
        data = {
          appId: null,
          mchId: null,
          pubKey: null,
          priKey: null,
          pubKeyId: null,
          serNum: null,
          v3Key: null
        };
      } else if (type === EXTERNAL_SERVICE_STATUS_.ALIPAY) {
        // 支付宝
        data = {
          appId: null,
          priKey: null,
          aliPubKey: null
        };
      } else if (type === EXTERNAL_SERVICE_STATUS_.ALIPAY_LOGIN) {
        // 支付宝
        data = {
          appId: null,
          priKey: null,
          aliPubKey: null
        };
      } else if (type === EXTERNAL_SERVICE_STATUS_.APPLE_LOGIN) {
        data = {
          clientIds: null,
          keysUrl: "https://appleid.apple.com/auth/keys"
        };
      } else if (type === EXTERNAL_SERVICE_STATUS_.DOUYIN_PAY) {
        data = {
          appId: null,
          mchId: null,
          merchantSerialNumber: null,
          merchantPrivateKey: null,
          platformCertificate: null,
          encryptKey: null,
          notifyUrl: null,
          refundNotifyUrl: null,
          callbackScheme: null,
          withdrawMode: "MANUAL"
        };
      } else if (EXTERNAL_SERVICE_STATUS_.JEEP_PAY === type) {
        // JEEP
        data = {
          appId: null,
          mchId: null,
          apiKey: null
        };
      } else if (EXTERNAL_SERVICE_STATUS_.YI_JIU === type) {
        // 壹玖
        data = {
          appId: null,
          mchId: null,
          apiKey: null,
          wechatCode: null,
          alipayCode: null
        };
      }
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.fg_comm {
  width: 100%;
  margin: 10px 0 20px;
  border: 1px dashed #eeeeee;
}
.field-help {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
::v-deep .el-card__header {
  padding: 0px;
}
.key_pre {
  //display: flex;
  //align-items: center;
  .key_pre_value {
    word-wrap: break-word;
    width: 100%;
  }
  .copy_key_pre {
    background-color: #11b95c;
    border-radius: 4px;
    color: #ffffff;
    height: 26px;
    line-height: 26px;
    margin-left: 20px;
    cursor: pointer;
    padding: 4px 8px;
    width: 30px;
  }
}
</style>
